module.exports = __webpack_public_path__ + "static/media/logo_full_white@2x.7506544e.png";